import styled from '@emotion/styled';

import RadioGroup from '../../../RadioGroup/RadioGroup';

export const StyledRadioGroup = styled(RadioGroup)`
  margin-bottom: 2.5rem;
`;
